<template>
  <div class="imc-help">
    <div class="imc-title">IMC轴常见问题</div>
    <div class="faq-list">
      <div v-for="(item, idx) in faqs" :key="idx">
        <div class="faq-q">{{ item.q }}</div>
        <div class="faq-a">{{ item.a }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const faqs = [
  {
    q: 'Q1：IMC的运行原理是什么？',
    a: 'A：IMC是通过硬件电路检测微小的按键动作。只要手指在按键下压过程中产生速度变化，系统就能立刻识别并触发。当用户开始按下按键时，按下加速度发生变化，触发按下按键动作。当用户开始松开按键时，抬起加速度发生变化，触发释放按键动作。',
  },
  {
    q: 'Q2：如果我在游戏中“匀速”按下按键，会不会导致IMC轴无法触发？',
    a: 'A：不会。IMC轴对加速度变化非常敏感。在实际游戏操作中，玩家的手指很难保持完全匀速的按下动作，通常会在按下瞬间产生细微但足够的加速度变化 —— 尤其是在按键接触的初期，这种变化更加明显。因此，IMC轴能够快速、准确地触发。',
  },
  {
    q: 'Q3：IMC轴需要校准吗？',
    a: 'A：不需要。传统磁轴需要对按键的物理行程（如触发行程与复位行程）进行识别，因此通常需要校准以确定按键的顶部和底部位置。而IMC轴基于加速度变化来触发信号，不依赖按键的实际物理行程，因此无需进行校准。',
  },
]
</script>

<style scoped lang="less">
.imc-help {
  width: 100%;
  padding: 24px 30px;
}
.imc-title {
  text-align: center;
  margin-bottom: 24px;
  font-size: 20px;
  font-weight: 800;
  color: var(--text-main);
}
.faq-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.faq-q {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 700;
  color: var(--brand-color-pure);
}
.faq-a {
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.6;
}
</style>
